import React from 'react';

const ExploreText = () => {
  return (
    <div>
      Imam Abu Yusuf Academy <br />
      <br />
      Ranking among the most eminent scholars in the United Kingdom, Shaykhul
      Hadith Hadhrat Mawlana Muhammad Bilal Sahib (may Allah lengthen his shadow
      over us) was born in the early sixties in Burma into a deeply religious
      household. <br />
      <br />
      He completed the memorisation of the Noble Qur’an at the very tender age
      of eight, and then continued his Islamic studies under the traditional
      Darse- Nizami in his homeland of Burma. He had studies to an advanced
      level before migrating to the UK, where he was afforded the opportunity of
      studying classical Arabic poetry, useful al-hadith and usul al-fiqh, under
      Shaykhul Hadith Hadhrat Mawlana Yusuf Motala Sahib (may Allah lengthen his
      shadow over us), founder and senior lecturer of the prestigious Darul
      Uloom Al-Arabiyya Al-Islamiyya, Bury. He went on to complete his studies
      and graduated par excellence from Mazahirul Uloom (Saharanpur, India), a
      renowned institute from which some of the greatest luminaries of the
      Indian Sub-Continent have hailed. Here he studied the major hadith
      collections under erudite scholars such as the renowned muhaddith of this
      era, Shaykhul Hadith Hadhrat Mawlana Yunus Jaunpuri (may Allah lengthen
      his shadow over us). What is noteworthy is that Shaykhul Hadith Hadhrat
      Mawlana Muhammad Bilal Sahib (may Allah lengthen his shadow over us) was
      barely sixteen years of age at the time of graduation. <br />
      <br />
      On his return to the UK after graduation, he was appointed lecturer of
      hadith at Darul Uloom Al-Arabiyya Al-Islamiyya whilst he was still in the
      prime of his youth, and he holds this position to date. Many hundreds of
      students from all parts of the world have had the fortune of studying the
      major books of hadith, in particular Sunan al-Nasa’I, under his tutelage.
      Alongside his expertise and proficiency in the Islamic sciences, evident
      from the fact that his teaching career began with the major hadith
      collections at a relatively young age, Shaykhul Hadith Hadhrat Mawlana
      Muhammad Bilal Sahib (may Allah lengthen his shadow over us) also
      benefitted in the science of Islamic spirituality (tasawwuf) from the
      undisputed imam and sufi master, Hadhrat Shaykhul Hadith Mawlana Muhammad
      Zakariyya Kandhlawi (d. 1982) – may Allah have mercy on him. <br />
      <br />
      Shaykhul Hadith Hadhrat Mawlana Muhammad Bilal Sahib (may Allah lengthen
      his shadow over us) was the last and youngest of his representative
      (khalifa) at the astounding age of 19, just a few months before the demise
      of Hadhrat Shaykhul Hadith Mawlana Muhammad Zakariyya Kandhlawi (may Allah
      have mercy on him). Besides his extensive travels both across the United
      Kingdom and other countries, Shaykhul Hadith Hadhrat Mawlana Muhammad
      Bilal Sahib (may Allah lengthen his shadow over us) has been selflessly
      serving the Muslim community in Bury for approximately thirty years.
      Countless people have benefitted, and continue to benefit, from his
      teachings and advice. His lighthearted and humble nature welcome people
      from all walks of life to benefit from his invaluable advice and
      teachings. <br />
      <br />
      Marked with a deep sense of love for Allah and His Messenger (sallallahu
      alayhi wasallam), and a heartfelt concern for the Muslim ummah, his
      charismatic speeches have always served as a source of inspiration and
      guidance, and those who have heard his lectures will testify to the deep
      impression his words leave on the listener. Allah has gifted him with a
      unique ability to explain the most intricate of matters in very simple
      terms, making his speeches understandable to one and all. Over the past
      few years, his daily speeches are broadcast live on the internet to allow
      people from all parts of the world benefit. <br />
      <br />
      With all these commitments, Shaykhul Hadith Hadhrat Mawlana Muhammad Bilal
      Sahib (may Allah lengthen his shadow over us) also finds the time to lead
      and advise many organisations across the UK, in particular a number of
      prominent charities whose humanitarian services extend across the globe.
      <br />
      <br />
      May Allah Most High preserve Shaykhul Hadith Mawlana Muhammad Bilal Sahib,
      grant him baraka in all aspects of his life, reward him immensely for his
      services to Islam and the Muslim ummah, and allow us all to benefit from
      him. Amin. <br />
      <br />
      Imam Abu Yusuf Academy has been established to relay authentic knowledge
      to all and instil with our hearts a true appreciation of the teachings of
      Islam, helping us to bring all aspects of our life in tune with the
      blessed way of Allah’s Messenger Muhammad (may Allah’s blessings and peace
      be upon him). Imam Abu Yusuf Ya’qub ibn Ibrahim (may Allah have mercy on
      him), among the greatest students of Imam Abu Hanifa Nu’man ibn Thabit
      (may Allah have mercy on him), and secondly from the fact that this is the
      kunya (teknonym) of Shaykhul Hadith Hadhrat Mawlana Muhammad Bilal Sahib
      from his eldest son, Yusuf.
    </div>
  );
};

export default ExploreText;
